export default {
    AvailableStartTime: 'AvailableStartTime',
    AvailableStartTimeMin: 'availableStartTime Min',
    AvailableStartTimeMax: 'availableStartTime Max',
    AvailableExpireTime: 'AvailableExpireTime',
    AvailableExpireTimeMin: 'availableExpireTime Min',
    AvailableExpireTimeMax: 'availableExpireTime Max',
    StateId: 'State'
}